import ValueObject from './ValueObject';

export default class DirectConnectionId extends ValueObject {}
